<!-- Encabezado del diálogo -->
<div mat-dialog-title class="dialog-header">
    <div class="header-content">
        <mat-icon class="header-icon">picture_as_pdf</mat-icon>
        <div class="header-text">
            <h2>Documentos PDF - DUS: {{ data.dus || numeroNroIE }}</h2>
            <p class="text-muted">Documentos PDF asociados al Control DUS</p>
        </div>
    </div>
    <button mat-icon-button (click)="cerrar()" class="close-button">
        <mat-icon>close</mat-icon>
    </button>
</div>

<!-- Contenido del diálogo -->
<mat-dialog-content class="dialog-content">
    <!-- Lista de archivos -->
    <div class="mat-mdc-card files-section">
        <div class="mat-mdc-card-header">
            <div class="mat-mdc-card-title">
                <mat-icon>description</mat-icon>
                Documentos PDF Asociados
            </div>
        </div>

        <div class="mat-mdc-card-content">
            <!-- Estado de carga -->
            <div *ngIf="isLoading" class="loading-container">
                <mat-spinner diameter="40"></mat-spinner>
                <p>Cargando archivos...</p>
            </div>

            <!-- Tabla de archivos -->
            <div class="table-container" *ngIf="!isLoading">
                <table mat-table [dataSource]="archivos" class="files-table">
                    <!-- Columna Selección -->
                    <ng-container matColumnDef="seleccion">
                        <th mat-header-cell *matHeaderCellDef>
                            <mat-checkbox
                                [checked]="isAllSelected()"
                                [indeterminate]="isIndeterminate()"
                                (change)="toggleSelectAll()"
                                color="primary"
                            ></mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let archivo">
                            <mat-checkbox
                                [checked]="selectedFileIds.has(archivo.id)"
                                (change)="toggleSelection(archivo)"
                                color="primary"
                            ></mat-checkbox>
                        </td>
                    </ng-container>

                    <!-- Columna Archivo -->
                    <ng-container matColumnDef="archivo">
                        <th mat-header-cell *matHeaderCellDef>Archivo</th>
                        <td mat-cell *matCellDef="let archivo">
                            <div class="file-info">
                                <mat-icon
                                    class="file-icon"
                                    [ngClass]="getFileIconClass(archivo)"
                                    [matTooltip]="
                                        getFileExtension(archivo) ||
                                        'Archivo'
                                    "
                                >
                                    {{ getFileIcon(archivo) }}
                                </mat-icon>
                                <span class="file-name">{{
                                    archivo.nombre
                                }}</span>
                            </div>
                        </td>
                    </ng-container>

                    <!-- Columna Tipo -->
                    <ng-container matColumnDef="tipo">
                        <th mat-header-cell *matHeaderCellDef>Tipo</th>
                        <td mat-cell *matCellDef="let archivo">
                            <mat-chip class="type-chip">{{
                                archivo.tipo
                            }}</mat-chip>
                        </td>
                    </ng-container>

                    <!-- Columna Nro. Documento -->
                    <ng-container matColumnDef="nroDocumento">
                        <th mat-header-cell *matHeaderCellDef>
                            Nro. Documento
                        </th>
                        <td mat-cell *matCellDef="let archivo">
                            {{ archivo.documentNumber || '—' }}
                        </td>
                    </ng-container>

                    <!-- Columna Creado por -->
                    <ng-container matColumnDef="creadoPor">
                        <th mat-header-cell *matHeaderCellDef>Creado por</th>
                        <td mat-cell *matCellDef="let archivo">
                            {{ archivo.creadoPor }}
                        </td>
                    </ng-container>

                    <!-- Columna Fecha creación -->
                    <ng-container matColumnDef="fechaCreacion">
                        <th mat-header-cell *matHeaderCellDef>
                            Fecha creación
                        </th>
                        <td mat-cell *matCellDef="let archivo">
                            {{ archivo.fechaCreacion }}
                        </td>
                    </ng-container>

                    <!-- Columna Acciones -->
                    <ng-container matColumnDef="acciones">
                        <th mat-header-cell *matHeaderCellDef>Acciones</th>
                        <td mat-cell *matCellDef="let archivo">
                            <button
                                mat-icon-button
                                color="primary"
                                (click)="descargarArchivo(archivo)"
                                [matTooltip]="
                                    isExcelFile(archivo)
                                        ? 'Descargar archivo Excel'
                                        : isPdfFile(archivo)
                                          ? 'Descargar archivo PDF'
                                          : 'Descargar archivo'
                                "
                                [disabled]="isLoading"
                            >
                                <mat-icon>download</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <!-- Definición de filas -->
                    <tr
                        mat-header-row
                        *matHeaderRowDef="[
                            'seleccion',
                            'archivo',
                            'tipo',
                            'nroDocumento',
                            'creadoPor',
                            'fechaCreacion',
                            'acciones'
                        ]"
                    ></tr>
                    <tr
                        mat-row
                        *matRowDef="
                            let row;
                            columns: [
                                'seleccion',
                                'archivo',
                                'tipo',
                                'nroDocumento',
                                'creadoPor',
                                'fechaCreacion',
                                'acciones'
                            ]
                        "
                    ></tr>
                </table>

                <!-- Mensaje sin archivos -->
                <div *ngIf="archivos.length === 0" class="no-files">
                    <mat-icon>folder_off</mat-icon>
                    <h3>No hay archivos</h3>
                    <p>
                        No se encontraron archivos adjuntos para este Control
                        DUS.
                    </p>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>

<!-- Acciones del diálogo -->
<mat-dialog-actions align="end" class="dialog-actions">
    <p
        *ngIf="getMensajeDescargaConsolidada() as mensaje"
        class="bulk-download-hint"
        role="status"
    >
        <mat-icon>info</mat-icon>
        <span>{{ mensaje }}</span>
    </p>
    <div class="dialog-actions-buttons">
        <button
            mat-raised-button
            color="primary"
            (click)="descargarSeleccionados()"
            [disabled]="!puedeDescargarSeleccionadosConsolidado() || isLoading"
            [matTooltip]="
                !puedeDescargarSeleccionadosConsolidado() &&
                selectedFileIds.size > 0
                    ? getMensajeDescargaConsolidada() || ''
                    : 'Descargar PDF consolidado de la selección'
            "
        >
            <mat-icon>download</mat-icon>
            Descargar seleccionados ({{ selectedFileIds.size }})
        </button>
        <button mat-stroked-button (click)="cerrar()">
            <mat-icon>close</mat-icon>
            Cerrar
        </button>
    </div>
</mat-dialog-actions>
